<template>
  <div id="swipeBanner" class="swipe-banner">
    <van-swipe
        class="my-swipe"
        :autoplay="data.intervalTime"
        :show-indicators="data.autoSwitch"
    >
      <van-swipe-item v-for="(image, index) in data.items" :key="index">
        <img :src="basePath + '/nonlogin/slideShow/attachment/' + image.imgURL + '.htm'" lazy-load @click="swipeHandle(image)"/>
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
import { baseURL } from "@/utils/url";
export default {
  name: "SwipeBanner",
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          intervalTime: 3000,
          autoSwitch: false,
          items: []
        }
      }
    }
  },
  data() {
    return {
      basePath: baseURL
    }
  },
  methods: {
    swipeHandle(image) {
      console.log(image);
    }
  }
}
</script>

<style lang="scss" scoped>
.my-swipe {
  height: 250px;
  img{
    width: 100%;
    height: 250px;
  }
}
</style>